import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { ThreeCircles } from "react-loader-spinner";
import './button.css'

/**
 * @param {{
 *   progress?: boolean,
 *   onclick: (e: any) => void,
 *   content: string,
 *   disable?: boolean,
 *   icon?: React.ReactNode,
 *   variant?: "default" | "modalPrimary" | "modalSecondary",
 *   type?: "button" | "submit" | "reset",
 *   className?: string,
 *   buttonStyle?: React.CSSProperties,
 *   wrapperStyle?: React.CSSProperties,
 * }} props
 */
export const CustomButton = ({
    progress,
    onclick,
    content,
    disable = false,
    icon = null,
    variant = "default",
    type = "submit",
    className = "",
    buttonStyle = {},
    wrapperStyle = {},
}) => {
    const [apiProgress, setApiProgress] = useState(progress)
    const [buttonContent, setButtonContent] = useState(content)
    const [isDisabledFlag, setIsDisabledFlag] = useState(disable)
    useEffect(() => {
        setApiProgress(progress !== undefined ? progress : false)
    }, [progress])

    useEffect(() => {
        setButtonContent(content)
    }, [content])

    useEffect(() => {
        setIsDisabledFlag(disable)
    }, [disable])

    const variantClassMap = {
        default: "custom-button",
        modalPrimary: "custom-button-modal-primary",
        modalSecondary: "custom-button-modal-secondary",
    };
    const shouldUseLegacyProgressStyle = apiProgress && variant === "default";
    const buttonClassName = [
        shouldUseLegacyProgressStyle ? "custom-button-api-progress" : variantClassMap[variant] || variantClassMap.default,
        className,
    ].filter(Boolean).join(" ");
    const defaultMargin = variant === "default" ? "0px 5px" : "0px";

    return (
        <div style={{ width: "fit-content", ...wrapperStyle }}>
            <Button
                type={type}
                onClick={(e) => onclick(e)}
                className={buttonClassName}
                disabled={isDisabledFlag}
                style={{ margin: defaultMargin, ...buttonStyle }}
            >
                {
                    !apiProgress ?
                        <>
                            {icon && <span style={{ marginRight: "5px" }}>{icon}</span>}
                            {buttonContent}
                        </>
                        :
                        <>
                            {buttonContent} &nbsp;
                            <ThreeCircles
                                height="15"
                                width="15"
                                color="#4fa94d"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel="three-circles-rotating"
                                outerCircleColor="var(--theme1_primary)"
                                innerCircleColor="var(--theme1_secondary)"
                                middleCircleColor="var(--theme1_tertiary)"
                            />
                        </>
                }
            </Button>
        </div>
    );
};
